import request from "@/utils/request";

//手机号密码登录
export function getVerifyCode(phone, biz) {
  return request({
    url: `/client/sms/getVerifyCode?phone=${phone}&biz=${biz}`,
    method: "get",
  });
}
